<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/e4UFzR/tc-custom/9781453253120.jpg?1733087822401" alt="This image is the cover for the book Foursome, The John Cuddy Mysteries"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Foursome, The John Cuddy Mysteries
      </h1>
      <p class="bookDescription body article font2">
        <b>Cuddy travels to Maine to investigate a gruesome lakeside murder</b>Steve always forgets to buy groceries on the way to the lake house. Every time he and his wife make a pilgrimage to Maine, his first task is to drive into town and pick up essentials. Today he leaves his wife at home with their two friends and returns from the store to find a crossbow on the lawn and arrows embedded in the chests of the three people he loves most. During a twenty-minute shopping trip, he has become the chief suspect in a triple murder. The case against him is airtight—fingerprints on the weapon, blood on his shoes—so Steve’s lawyer hires Boston PI John Francis Cuddy to crack it. Steve’s lakeside neighbors had no love for his yuppie pals, but did they hate the city slickers enough to frame him for murder? Cuddy learns quickly that in Maine, even the killers are awfully polite.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jeremiah Healy
      </h2>
      
      <p class="authorDescription body article">Jeremiah Healy (1948&ndash;2014) was the creator of the John Cuddy mystery series and the author of several legal thrillers. A graduate of Rutgers College and Harvard Law School, Healy taught at the New England School of Law before becoming a novelist. He published his first novel,&#160;<I>Blunt Darts</I>, in 1984, introducing John Francis Cuddy, the Boston private eye who would become Healy&rsquo;s best-known character.<BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?f4667fea